export default __webpack_public_path__ + "static/media/logo_cruzdelnorte.84786a3b.png";